export enum UserType {
    customerUser = 'customer_user',
    staffUser = 'staff_user'
}

export enum ApplicationNames {
    Platform = 'Platform',
    RequestManagement = 'Request Management',
    YourProductsAndServices = 'Your products and services',
    NetworkPerformanceReports = 'Network Performance Reports',
    Tracking = 'Tracking',
    OrderTracker = 'Order Tracker',
    StatusTracker = 'Status Tracker',
    IncidentManagement = 'Incident Management',
    Billing = 'Billing',
    MobileDataUsageMeter = 'Mobile Data Usage Meter',
    OrderExpress = 'Order Express',
    Ips = 'IPS',
    TpamsReports = 'TPAMS reports',
    PlannedMaintenance = 'Planned Maintenance',
    OnlineOrdering = 'Online Ordering',
    Quotes = 'Quotes',
    Support = 'Support',
    OpsHub = 'Ops Hub',
    ChannelCare = 'Channel Care',
    UnifiedTracking = 'Unified Tracking',
    CscTracking = 'CSC Tracking',
    AccountTeams = 'Account Teams',
    StaffSelectCompany = 'Staff Select Company',
    UserManagement = 'User-Management',
    TermsAndConditions = 'Terms and Conditions',
    ErrorPages = 'Error Pages',
    Mobility = 'Mobility',
    StoreInt = 'StoreInt',
    CustomerSupport = 'Customer Support'
}
